export const DeviceUserCreateSceneTranslation = {
  fi: {
    DeviceUserCreateScene: {
      title: 'Lisää uusi käyttäjä',
      saveAndMoveToDepartments: 'Tallenna ja määritä osastot',
    },
  },
};
